/**
 * @typedef {Object} GAProduct
 * @property {string} id
 * @property {string} variant
 * @property {string} name
 * @property {string} brand
 * @property {string} category
 * @property {string} list
 * @property {number} price
 * @property {number} quantity
 * @property {string} dimension89 type of subscription (autoship or oneTime)
 * @property {string} dimension90 pet
 * @property {string} dimension94 variant id
 * @property {string} dimension104 is there a discount
 * @property {string} dimension106 is an rx required
 * @property {string} dimension107 strength
 * @property {string} dimension108 packaging
 * @property {string} dimension110 product name with "Bundle" appended
 * 
 * @typedef {Object} ProductDetails
 * @property {string} id
 * @property {string} variantId
 * @property {string} name
 * @property {string} brand
 * @property {string} category
 * @property {string} list
 * @property {number} price
 * @property {number} quantity
 * @property {string} autoshipFrequency
 * @property {string} pet
 * @property {boolean} discount
 * @property {boolean} rxRequired
 * @property {string} strength
 * @property {string} packaging
 */

/**
 * @param {ProductDetails}
 * @returns {GAProduct}
 */
 function buildProduct(productDetails) {
    const {
        id,
        variantId,
        name,
        brand,
        category,
        list,
        price,
        quantity,
        autoshipFrequency,
        pet,
        discount,
        rxRequired,
        strength,
        packaging 
    } = productDetails;

    let autoship = autoshipFrequency;
    if(typeof autoship === 'number') {
        autoship = autoship > 0 ? 'autoship' : 'oneTime';
    }

    let discountValue = discount;
    if(typeof discountValue === 'boolean') {
        discountValue ? 'yes' : 'no';
    }

    let rxRequiredValue = rxRequired;
    if(typeof rxRequiredValue === 'boolean') {
        rxRequiredValue ? 'yes' : 'no';
    }

    return {
        'id': id,
        'variant': variantId,
        'name': name,
        'brand': brand,
        'category': category,
        'list': list,
        'price': price,
        'quantity': quantity,
        'dimension89': autoship,
        'dimension90': pet,
        'dimension94': variantId,
        'dimension104': discountValue,
        'dimension106': rxRequiredValue,
        'dimension107': strength,
        'dimension108': packaging,
        'dimension110': name ? name + ' Bundle' : undefined
    };
}

window.VCA = window.VCA || {};

window.VCA.productDatalayer = {
    buildProduct
};

export {
    buildProduct
};
